import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';

const DailyChallengePromoSection = () => {
  return (
    <section className="relative overflow-hidden px-4 py-8 sm:px-6 lg:px-8 lg:py-10">
      <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(255,255,255,0.85),rgba(239,246,255,0.78))]" />
      <div className="absolute left-[-4rem] top-8 h-36 w-36 rounded-full bg-[#7c3aed]/10 blur-3xl" />
      <div className="absolute right-[-4rem] bottom-4 h-40 w-40 rounded-full bg-[#0ea5e9]/10 blur-3xl" />

      <div className="relative mx-auto max-w-7xl">
        <div className="mx-auto flex max-w-4xl flex-col gap-4 rounded-[32px] border border-white/80 bg-white/85 p-4 shadow-[0_24px_60px_rgba(2,132,199,0.10)] backdrop-blur-sm sm:p-5 lg:flex-row lg:items-center lg:justify-between lg:p-6">
          <div className="flex items-start gap-4 text-left">
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-[#7c3aed] to-[#0ea5e9] text-white shadow-[0_14px_28px_rgba(14,165,233,0.18)]">
              <Sparkles className="h-5 w-5" />
            </div>
            <div>
              <p className="text-[10px] font-bold uppercase tracking-[0.22em] text-[#7c3aed]">Daily Challenge</p>
              <h2 className="mt-1 text-xl font-bold text-[#1f1f23] sm:text-2xl">Neon Maze & Reflex Tap</h2>
              <p className="mt-2 max-w-2xl text-sm leading-6 text-[#5a4d63] sm:text-[15px]">
                Daily neon navigation plus fast-finger reflex practice. Compete on the leaderboard and build a streak.
              </p>
            </div>
          </div>

          <div className="flex shrink-0 flex-col gap-3 sm:flex-row">
            <Link
              to="/daily-challenge"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-[#7c3aed] to-[#0ea5e9] px-5 py-3 text-sm font-semibold text-white shadow-[0_14px_28px_rgba(2,132,199,0.25)] transition-transform duration-300 hover:scale-[1.02]"
            >
              Start Daily Challenge
              <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DailyChallengePromoSection;

